import React, { FC } from 'react'
import DiscountReportContainer from 'containers/DiscountReport'

const DiscountReportPage: FC = () => <DiscountReportContainer />

export default DiscountReportPage
